import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API_BASE_URL from "../services/apiClient";

const JoinTripPage = () => {

  const { token } = useParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState("joining");

  useEffect(() => {

    const joinTrip = async () => {

      const authToken =
        localStorage.getItem("token") ||
        sessionStorage.getItem("token");

      // 🔐 USER NOT LOGGED IN
     // 🔐 USER NOT LOGGED IN
if (!authToken) {

  // Save invite token so we can join after login
  localStorage.setItem("pendingTripJoin", token);

  // open login modal
  window.dispatchEvent(new Event("openLogin"));

  setStatus("login");

  return;
}

      try {

        const res = await fetch(
          `${API_BASE_URL}/api/trips/invite/${token}/join`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authToken}`
            }
          }
        );

        const data = await res.json();

        if (res.ok) {

          setStatus("success");

          // redirect to trip hub
          setTimeout(() => {
            navigate(`/trip/${data.travelKeyToken}`);
          }, 1200);

        } else {

          setStatus("error");

        }

      } catch (err) {

        setStatus("error");

      }

    };

    joinTrip();

  }, [token, navigate]);

  return (

    <div className="min-h-screen flex items-center justify-center bg-[#fdfcf7]">

      <div className="bg-white p-10 rounded-2xl border border-gray-100 shadow-sm text-center max-w-md">

        {status === "joining" && (
          <>
            <div className="w-12 h-12 border-4 border-[#5b6f00] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <h2 className="text-lg font-bold text-gray-900">
              Joining Trip...
            </h2>
          </>
        )}

       {status === "login" && (
  <>
    <h2 className="text-lg font-bold text-gray-900 mb-3">
      Please login to join this trip
    </h2>

    <p className="text-sm text-gray-500 mb-6">
      Sign in to collaborate on this trip.
    </p>

    <button
      onClick={() => window.dispatchEvent(new Event("openLogin"))}
      className="px-6 py-2 bg-[#5b6f00] text-white rounded-lg font-semibold hover:bg-[#4c5c00] transition"
    >
      Login to Join Trip
    </button>
  </>
)}

        {status === "success" && (
          <>
            <h2 className="text-xl font-bold text-[#5b6f00] mb-2">
              Welcome to the Trip 🎉
            </h2>
            <p className="text-sm text-gray-500">
              Redirecting you to the trip hub...
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <h2 className="text-xl font-bold text-red-500 mb-2">
              Invite Failed
            </h2>
            <p className="text-sm text-gray-500">
              This invite link is invalid or expired.
            </p>
          </>
        )}

      </div>

    </div>

  );

};

export default JoinTripPage;